<template>
	<el-container id="guide">
		<div>
			<div class="guide material">
				<div class="titBox" style="margin-top:0;">
					<p class="tit">通知公告</p>
					<!-- <div class="fl label_category">
						<div v-for="(item) in tag_list" :key="item.key" @click="this_color(item.id)" :style="tag_id==item.id?item.style:''">{{item.title}}</div>
					</div> -->
                    <div class="inp">
                        <i class="el-icon-search"></i>
                        <input type="text" placeholder="搜索" @input="search_tim_fn()" v-model="title">
                    </div>
				</div>
        	</div>	
			<announcement></announcement>
		</div>
        
	</el-container>
</template>

<script>
import announcement from '@/components/dyy_assembly/announcement.vue'
export default {
	name: 'material'
	,data () {
		return {
			title:''
		}
	}
	,mounted:function(){
	}
	,watch:{
		total(){

		}
	}
	,computed:{

	}
	,components:{
        announcement
    }
	,methods:{

        search_tim_fn(){
			return false
            let that = this
            if (this.search_tim_obj) {
                clearTimeout(this.search_tim_obj)        
            }
            this.search_tim_obj = setTimeout(function(){
                that.getguide(true)
            },1000)
        },

	}
	,destroyed:function(){
		window.removeEventListener('scroll',this.getScrollPosition,false)
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/notice_announcement/announcement_list.vue